/* if ($('.id--15').length) {
  var text = $('.co-payment-method .recapitulation-table td[data-testid="recapPaymentMethod"]').text().trim();
  var checkoutDone;

  if (paymentGroups.bankTransfer.some(txt => text.includes(txt))) {
    checkoutDone = 'Děkujeme, vaše objednávka bude zaplacena bankovním převodem!';
  } else if (paymentGroups.card.some(txt => text.includes(txt))) {
    checkoutDone = 'Děkujeme, platba kartou byla úspěšná!';
  } else if (paymentGroups.cod.some(txt => text.includes(txt))) {
    checkoutDone = 'Děkujeme, zaplaťte prosím při převzetí zásilky.';
  } else if (paymentGroups.cash.some(txt => text.includes(txt))) {
    checkoutDone = 'Děkujeme, zaplaťte prosím při převzetí zásilky.';
  } else {
    checkoutDone = $('.order-summary-heading').text();
  }

  var recaNumber = $('.reca-number strong').text()
  $('header#header').after(`
    <div class="checkoutFormTop"> 
    <div class="container">
      <div class="image">
        <img src="/user/documents/upload/sablona-nemazat/ico/thumb.svg" alt="Utopy objednávka">
      </div>
      <div class="h1">${checkoutDone}</div>
      <p>Objednávka číslo: <strong>${recaNumber}</strong></p>
    </div>  
    </div>
  `)
  $('.recapitulation-wrapper .order-summary-item.total').before('<div class="suitUp"><p>' + suitUp + '</p></div>')
  $('.cart-table tr[data-testid="recapItem"]').each(function () {
    $(this).find('.p-price').prepend('<div class="unitTotal">' + $(this).find('.p-quantity').html() + '</div>')
  })
} */

if ($(".id--15").length) {
  $(".co-box.co-order .order-icon.order-content").text("Souhrn objednávky");
  const shipping = JSON.parse(localStorage.getItem("selectedShipping"));
  const payment = JSON.parse(localStorage.getItem("selectedPayment"));
  if (shipping || payment) {
    const $box = $('<div class="co-box co-added"></div>');
    const shippingPointHtml = shipping && shipping.point ? `<span class="recapDeliveryPoint">${shipping.point}</span>` : "";
    const html = `
        <div class="recapShippingPayment">
          ${
            shipping
              ? `
          <div class="recapShippingPayment__item">
            ${shipping.img ? `<img src="${shipping.img}" alt="${shipping.name}">` : ""}
             <strong>${shipping.name}</strong>
            <div class="recapShippingPayment__info">
              ${shippingPointHtml}
            </div>
          </div>`
              : ""
          }
          ${
            payment
              ? `
          <div class="recapShippingPayment__item">
            ${payment.img ? `<img src="${payment.img}" alt="${payment.name}">` : ""}
             <strong>${payment.name}</strong>
           
          </div>`
              : ""
          }
        </div>
      `;
    $box.append(html);
    $(".co-box.co-order").after($box);
    $(".co-box.co-added").prepend("<h4>Doprava a platba</h4>");

    $('.co-payment-method tbody tr td[data-testid="recapDeliveryMethod"]')
      .closest("tr")
      .append('<span class="price">' + shipping.price + "</span>");
    $('.co-payment-method tbody tr td[data-testid="recapPaymentMethod"]')
      .closest("tr")
      .append('<span class="price">' + payment.price + "</span>");
  }

  var dphRaw = $('.co-payment-method tbody tr td strong[data-testid="orderTotalPrice"]').text().trim();
  var dphNum = parseFloat(dphRaw.replace(/[^\d,]/g, "").replace(",", "."));

  if (!isNaN(dphNum)) {
    var noDphNum = ((dphNum / 121) * 100).toFixed(2).replace(".", ",");
    $('.co-payment-method tbody tr td strong[data-testid="orderTotalPrice"]').closest("tr").after(`<tr class="noDph"><th>Cena bez DPH</th><td><strong>${noDphNum} Kč</strong></td></tr>`);

    var shippingNum = 0;
    var paymentNum = 0;

    if (shipping && shipping.price && shipping.price.trim().toLowerCase() !== "zdarma") {
      shippingNum = parseFloat(shipping.price.replace(/[^\d,]/g, "").replace(",", ".")) || 0;
    }
    if (payment && payment.price && payment.price.trim().toLowerCase() !== "zdarma") {
      paymentNum = parseFloat(payment.price.replace(/[^\d,]/g, "").replace(",", ".")) || 0;
    }

    var zbozi = (dphNum - shippingNum - paymentNum).toFixed(2);
    var zboziFormatted = parseFloat(zbozi).toLocaleString("cs-CZ", { minimumFractionDigits: 0, maximumFractionDigits: 2 });

    $('.co-payment-method tbody tr td strong[data-testid="orderTotalPrice"]').closest("tr").before(`<tr class="zboziTotal"><th>Celkem za zboží</th><td><strong>${zboziFormatted} Kč</strong></td></tr>`);
  }

  $(".recapitulation-wrapper .co-order").append($(".order-complete-links .btn").clone());

  $('.cart-table tr[data-testid="recapItem"] td.p-name').each(function () {
    const $td = $(this);
    const $br = $td.find("br");
    if (!$br.length) return;

    const variantNode = $br[0].nextSibling;
    if (!variantNode || variantNode.nodeType !== 3) return;

    const text = variantNode.textContent.trim();
    if (!text) return;

    const parts = text.split(", ");
    const result = parts
      .map((part, index) => {
        const idx = part.indexOf(":");
        const separator = index < parts.length - 1 ? ' <span class="superLabelSeparator">|</span>' : "";
        if (idx !== -1) {
          const label = part.substring(0, idx + 1);
          const rest = part.substring(idx + 1);
          return `<span class="superLabel"><b>${label}</b>${rest}${separator}</span>`;
        }
        return `<span class="superLabel">${part}${separator}</span>`;
      })
      .join(" ");

    $(variantNode).replaceWith($('<span class="main-link-variant"></span>').html(result));
  });

  getBannersLine();

  $(document).ready(function () {
    $(".recapitulation-wrapper:has(.order-complete-links)").after($("#footer .social-reviews .social").clone());
  });
  getHpBlog(function () {
    if (typeof loadDescBlogNew === "function") {
      loadDescBlogNew();
    }
  });
}
